import { transport } from 'config/transport';

export function callApiGetListOfDanhMucDuChiCaNhan() {
    return transport.get(`/congdoan/thuchi/chicongdoan/danhmuc/duchicanhan`);
}
